import { h } from 'preact'
import { useState, useEffect } from 'preact/hooks'
import SearchContext from './SearchContext'
import SearchDriver from './SearchDriver'

const SearchProvider = ({ children, config = {}, driver }) => {
    const [driverInstance, setDriverInstance] = useState(null)

    useEffect(() => {
        const currentDriver =
            driver ||
            new SearchDriver({
                ...config,
            })

        setDriverInstance(currentDriver)
    }, [config, driver])

    useEffect(() => {
        if (driverInstance) driverInstance._updateSearchResults()
    }, [driverInstance])

    if (!driverInstance) return null

    return (
        <SearchContext.Provider value={{ driver: driverInstance }}>
            {children}
        </SearchContext.Provider>
    )
}

export default SearchProvider
